import React, { useState } from "react";
import { Box, Button, Dialog } from "@mui/material";
import { DialogContent, Stack, TextField, Typography } from "@mui/material";
import { applyDiscount } from "./saleSlice";
import { useDispatch } from "react-redux";

function AddDiscount({ onClose }) {
  const dispatch = useDispatch();
  const [discount, setDiscount] = useState(0);

  const handleDiscount = (e) => {
    setDiscount(e.target.value);
  };

  const addGroupDiscount = () => {
    dispatch(applyDiscount(discount));
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing="24px">
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Apply discount
          </Typography>
          <TextField
            autoFocus
            size="small"
            label="Discount"
            type="number"
            fullWidth
            name="discount"
            variant="outlined"
            value={discount}
            onChange={handleDiscount}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <Button
              variant="contained"
              sx={{ background: "#999999 !important" }}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button variant="contained" onClick={addGroupDiscount}>
              Submit
            </Button>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddDiscount;
